// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-skins-smallOnConfined-badge-491ab64a"};